import { useEffect, useRef } from 'react';

export const useScrollAnimation = (options = {}) => {
	const elementRef = useRef(null);

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add('animate-in');
					}
				});
			},
			{
				threshold: options.threshold || 0.1,
				...options,
			}
		);

		const current = elementRef.current;
		if (current) {
			observer.observe(current);
		}

		return () => {
			if (current) {
				observer.unobserve(current);
			}
		};
	}, [options]);

	return elementRef;
};
